<!--  -->
<template>
  <div class="search-div">
    <span class="icon"></span>
    <el-input
      v-model="keyword"
      placeholder="Type here to search"
      @keyup.enter.native="getTaxonList"
    ></el-input>
  </div>
</template>

<script>
import { utlogMap } from "@/api/index";
import { functionId } from "@/utils/browser.js";
export default {
  name: "v-search",
  data() {
    return {
      keyword: "",
    };
  },
  beforeRouteUpdate(to, from, next) {
    // to：目标路由对象
    // from：原路由对象
    // next：可指定路由进行跳转
    console.log(to, from);
    //    next();
  },
  //生命周期 - 创建完成（访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（访问DOM元素）
  mounted() {},
  methods: {
    getTaxonList() {
      let currentKeyword = this.$route.query.keyword;
      if (currentKeyword == this.keyword) {
        //   this.$router.go(0);
        return;
      }
      let logMap = {
        eventType: "search",
        url: window.location.href,
        functionId: 'Deepbone_header_search',
        utlogMap:{
          keywords:{
            keyword:this.keyword
          }
        }
      };
      utlogMap(logMap).then((res) => {
        // console.log(res);
      });
      
      this.$router.replace({
        name: "TopSearchList",
        query: {
          keyword: this.keyword,
        },
      });
    },
  },
};
</script>
<style>
.search-div {
  position: relative;
  width: 229px;
}
.search-div .el-input {
  height: 36px;
  mix-blend-mode: darken;
  border-radius: 4px;
  background-color: rgba(218, 218, 218, 0.6);
}
.search-div .icon {
  width: 22px;
  height: 22px;
  position: absolute;
  left: 12px;
  top: 8px;
  background: url("../assets/images/search.png") no-repeat center;
  background-size: 22px;
}
.search-div .el-input__inner {
  height: 36px !important;
  line-height: 36px !important;
  background-color: transparent !important;
  padding: 0 15px 0 34px !important;
  font-size: 16px !important;
  border: none;
  color: #484d63 !important;
}
.search-div .el-input__inner:focus {
  border-color: transparent !important;
}
input::-webkit-input-placeholder {
  color: #c4c4c4 !important;
}
input::-moz-input-placeholder {
  color: #c4c4c4 !important;
}
input::-ms-input-placeholder {
  color: #c4c4c4 !important;
}
</style>
